import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  Row,
  Col,
  Table,
  Badge,
  Dropdown,
  Modal,
} from "react-bootstrap";
import InfoIcon from "@mui/icons-material/Info";
import ArrowBack from "@mui/icons-material/ArrowBack";
import {
  ChevronDown,
  ChevronUp,
  User,
  History,
  FileText,
} from "lucide-react";
import DOMPurify from "dompurify";
import { DETAILS_BG, filterPopoverStyles, tableStyles } from "Constants/Style";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  fetchProductSalesOrderById,
  fetchServiceSalesOrderById,
} from "slices/sales_order/thunk";
import { MecordColors } from "Constants/Color";
import StatusRemarksHistory from "pages/Enquiry/Components/StatusRemarksHistory";
import moment from "moment";
import LoadingSpinner from "components/LoadingSpinner";
import PageContainer from "Common/Components/PageContainer/PageContainer";
import { AttachmentList } from "components/DocumentListing/AttachmentListing";
import CancelButton from "Common/Components/Buttons/CancelButton";
import { formatIndianAmount } from "helpers/formatIndianAmount";

const ViewProductSalesOrderPage: React.FC<{ id?: string }> = ({ id: propId }) => {
  const { id: urlId, activeType } = useParams<{ id: string; activeType: string }>();
  const id = propId || urlId;
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();

  // Redux state with safe fallback
  const salesOrderState = useSelector(
    (state: any) =>
      state.SalesOrder || {
        currentSalesOrder: state,
        loading: false,
        error: null,
      }
  );

  const chunkArray = (arr: any[], size = 2) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };



  const formatDateForDisplay = (dateString: string | null | undefined): string => {
    if (!dateString) return "";
    // If it's already in YYYY-MM-DD format, return as is
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return dateString;
    }
    // If it's a UTC ISO string, convert to local date using moment
    if (dateString.includes("T") || dateString.includes("Z")) {
      const date = moment(dateString);
      if (!date.isValid()) return "";
      return date.format("YYYY-MM-DD");
    }
    return dateString;
  };
  const { currentSalesOrder, loading, error } = salesOrderState;
  // console.log("currentSalesOrder : => ", currentSalesOrder);
  //  console.log("salesOrder in view sales order page : => ", salesOrder);

  //   id: 101,
  //   sales_order_number: "SO-2024-00125",
  //   status: "pending",
  //   initiated_by: "Rahul Sharma",
  //   order_date: "2024-09-15",
  //   eta_date: "2024-09-25",
  //   industry: "Manufacturing",
  //   company_name: "Mecord Systems Pvt Ltd",

  //   contact_person_name: "Amit Verma",
  //   contact_person_email: "amit.verma@mecord.com",
  //   contact_person_phone_no: "9876543210",

  //   terms_and_conditions: "Payment within 30 days from invoice date.",
  //   notes: "Handle with care during transportation.",
  //   payment_terms: "30 Days Credit",

  //   contact_persons: [
  //     {
  //       contact_person_name: "Amit Verma",
  //       contact_person_email: "amit.verma@mecord.com",
  //       contact_person_phone: "9876543210",
  //     },
  //     {
  //       contact_person_name: "Neha Singh",
  //       contact_person_email: "neha.singh@mecord.com",
  //       contact_person_phone: "9123456780",
  //     },
  //   ],

  //   attachments: [
  //     {
  //       file_url: "https://example.com/po_documents/PO_125.pdf",
  //       file_name: "Customer_PO_125.pdf",
  //     },
  //   ],

  //   item_details: [
  //     {
  //       id: 1,
  //       item_name: "Industrial Pressure Sensor",
  //       category_name: "Sensors",
  //       sub_category_name: "Pressure Sensors",
  //       make_name: "Bosch",
  //       model_name: "PS-900X",
  //       product_code: "BOS-PS-900X",

  //       is_serviceable: true,
  //       installation_required: true,
  //       inspection_required: true,

  //       installation_date: "2024-09-20",
  //       inspection_date: "2024-09-22",

  //       quantity: 10,
  //       unit: "Nos",
  //       unit_price: 4500,
  //       discount_type: "Percentage",
  //       discount_value: 500,
  //       net_value: 4000,

  //       gst_percent: 18,
  //       sgst_percent: 9,
  //       cgst_percent: 9,
  //       igst_percent: 0,

  //       gst_value: 720,
  //       total: 4720,

  //       shipping_address: {
  //         shipping_id: 501,
  //         address: "Plot No. 23, MIDC Industrial Area",
  //         city: "Pune",
  //         state: "Maharashtra",
  //         country: "India",
  //         pin_code: "411026",
  //         phone_number: "020-27654321",
  //       },

  //       item_availability: "In Stock",
  //     },
  //     {
  //       id: 2,
  //       item_name: "Temperature Controller",
  //       category_name: "Controllers",
  //       sub_category_name: "Temperature Controllers",
  //       make_name: "Siemens",
  //       model_name: "TC-450",
  //       product_code: "SIE-TC-450",

  //       is_serviceable: false,
  //       installation_required: false,
  //       inspection_required: false,

  //       installation_date: null,
  //       inspection_date: null,

  //       quantity: 5,
  //       unit: "Nos",
  //       unit_price: 7800,
  //       discount_type: "Flat",
  //       discount_value: 800,
  //       net_value: 7000,

  //       gst_percent: 18,
  //       sgst_percent: 9,
  //       cgst_percent: 9,
  //       igst_percent: 0,

  //       gst_value: 1260,
  //       total: 8260,

  //       shipping_address: {
  //         shipping_id: 502,
  //         address: "Unit 5, Electronic City",
  //         city: "Bengaluru",
  //         state: "Karnataka",
  //         country: "India",
  //         pin_code: "560100",
  //         phone_number: "080-44556677",
  //       },

  //       item_availability: "Limited Stock",
  //     },
  //   ],

  //   agent: {
  //     agent_name: "Suresh Patil",
  //   },
  //   billing_address: null,
  // };

  // Extract the actual sales order data (handle both nested and direct structures)
  const salesOrder = currentSalesOrder?.data || currentSalesOrder;

  // Description & Additional Details modals (view only)
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [descriptionModalContent, setDescriptionModalContent] = useState("");
  const [descriptionModalProductName, setDescriptionModalProductName] = useState("");
  const [showAdditionalDetailsModal, setShowAdditionalDetailsModal] = useState(false);
  const [additionalDetailsContent, setAdditionalDetailsContent] = useState("");
  const [additionalDetailsProductName, setAdditionalDetailsProductName] = useState("");
  // console.log("salesOrder in view sales order page : => ", salesOrder);
  // Get contact details from customer_details
  const customerDetails = salesOrder?.customer_details || {};
  const contactPersons = customerDetails?.contact_details || [];
  const contactDetails = contactPersons?.[0] || {};

  // Get agent details
  const agent = { agent_name: salesOrder?.agent_name || "-" };

  // Get billing addresses
  const billFrom = salesOrder?.bill_from || {};
  const billTo = salesOrder?.bill_to || {};

  // Format date helper - converts UTC to local date for display using moment
  const formatDate = (dateString: string | null | undefined): string => {
    if (!dateString) return "-";
    try {
      const date = moment(dateString);
      if (!date.isValid()) return "-";
      return date.format("DD-MMM-YYYY");
    } catch {
      return "-";
    }
  };

  // Format date as DD-MM-YYYY for retention follow-up date - converts UTC to local date using moment
  const formatDateDDMMYYYY = (dateString: string | null | undefined): string => {
    if (!dateString) return "-";
    try {
      const date = moment(dateString);
      if (!date.isValid()) return "-";
      return date.format("DD-MM-YYYY");
    } catch {
      return "-";
    }
  };

  // Helper function to get follow-up date by category from sales_order_follow_ups
  const getFollowUpDateByCategory = (
    category: string,
    useNextFollowUpDate: boolean = true
  ): string | null => {
    if (!salesOrder?.sales_order_follow_ups || !Array.isArray(salesOrder.sales_order_follow_ups)) {
      return null;
    }

    // Case-insensitive search for category
    const followUp = salesOrder.sales_order_follow_ups.find(
      (item: any) =>
        item.follow_up_category?.toLowerCase() === category.toLowerCase()
    );

    if (!followUp) return null;

    if (useNextFollowUpDate && followUp.next_follow_up_date) {
      return followUp.next_follow_up_date;
    }

    if (followUp.follow_up_date) {
      return followUp.follow_up_date;
    }

    return null;
  };

  // Format terms and conditions array
  const formatTermsAndConditions = (
    terms: any[] | string | null | undefined
  ): string | React.ReactNode | null => {
    if (!terms) return null;

    // If it's already a string, return it
    if (typeof terms === "string") {
      // Check if it's a JSON string
      if (terms.trim().startsWith("[") || terms.trim().startsWith("{")) {
        try {
          const parsed = JSON.parse(terms);
          if (Array.isArray(parsed)) {
            return formatTermsArray(parsed);
          }
          return terms;
        } catch {
          return terms;
        }
      }
      return terms;
    }

    // If it's an array, format it
    if (Array.isArray(terms)) {
      if (terms.length === 0) return null;
      return formatTermsArray(terms);
    }

    // Fallback
    return null;
  };

  // Helper function to format terms array
  const formatTermsArray = (termsArray: any[]): React.ReactNode => {
    if (!Array.isArray(termsArray) || termsArray.length === 0) {
      return null;
    }

    // Group terms by type to handle multiple options per type
    const groupedTerms: Record<string, string[]> = {};
    termsArray.forEach((item: any) => {
      if (item.type) {
        if (!groupedTerms[item.type]) {
          groupedTerms[item.type] = [];
        }
        // Handle both string and array options
        if (Array.isArray(item.options)) {
          item.options.forEach((opt: string) => {
            if (
              opt &&
              !groupedTerms[item.type].includes(opt)
            ) {
              groupedTerms[item.type].push(opt);
            }
          });
        } else if (item.options) {
          // If options is a string, check if it's newline-separated
          const options = item.options
            .split("\n")
            .filter((opt: string) => opt.trim());
          options.forEach((opt: string) => {
            if (
              opt &&
              !groupedTerms[item.type].includes(opt)
            ) {
              groupedTerms[item.type].push(opt);
            }
          });
        }
      }
    });

    return (
      <>
        {Object.entries(groupedTerms).map(
          ([type, options], idx) => (
            <div key={idx} className="mb-3">
              <strong
                style={{
                  fontSize: "0.75rem",
                  display: "block",
                  marginBottom: "0.5rem",
                }}
              >
                {type}
              </strong>
              <ul
                style={{
                  fontSize: "0.7rem",
                  color: "#666",
                  marginLeft: "20px",
                  paddingLeft: "0",
                  listStyle: "disc",
                }}
              >
                {options.map(
                  (option: string, optIdx: number) => (
                    <li
                      key={optIdx}
                      style={{ marginBottom: "4px" }}
                    >
                      {option}
                    </li>
                  )
                )}
              </ul>
              {idx <
                Object.keys(groupedTerms).length - 1 && (
                  <hr
                    style={{
                      width: "100%",
                      marginTop: "12px",
                    }}
                  />
                )}
            </div>
          )
        )}
      </>
    );
  };

  // Transform status remarks and history from backend to UI format
  const transformStatusRemarks = (remarks: any[] | null | undefined) => {
    if (!remarks || !Array.isArray(remarks) || remarks.length === 0) {
      return [];
    }

    const packingStatusColors: { [key: string]: string } = {
      "Pending Issue": "#0d6efd",
      "Packing Initiated": "#198754",
      "Delivered": "#198754",
      "On Hold": "#dc3545",
      "Draft": "#6c757d",
      "Closed": "#198754",
    };



    const colors = [
      { bg: "#fee2e2", circle: "#ef4444", text: "#991b1b" },
      { bg: "#ccfbf1", circle: "#0d9488", text: "#115e59" },
      { bg: "#e0e7ff", circle: "#4f46e5", text: "#3730a3" },
      { bg: "#fef3c7", circle: "#d97706", text: "#92400e" },
    ];

    return remarks.map((item: any, index: number) => {
      const username = item.username || "Unknown";
      const nameParts = username.split(" ");
      const initials =
        nameParts.length >= 2
          ? `${nameParts[0][0]}${nameParts[1][0]}`.toUpperCase()
          : username.substring(0, 2).toUpperCase();

      const status = item.sales_order_status || "-";
      const statusColor = packingStatusColors[status] || "#6c757d";

      // Convert UTC date to local date using moment
      const date = item.created_at
        ? moment(item.created_at)
        : moment();

      // Validate date before formatting
      if (!date.isValid()) {
        return {
          employee_name: username,
          initials: initials,
          status: status,
          statusColor: statusColor,
          color: colors[index % colors.length].circle,
          date: "-",
          time: "-",
          comment: item.remark || item.comment || "-",
        };
      }

      const formattedDate = date.format("DD-MMM-YYYY");
      const formattedTime = date.format("hh:mm A");

      const color = colors[index % colors.length];

      return {
        employee_name: username,
        initials: initials,
        status: status,
        statusColor: statusColor,
        color: color.circle,
        date: formattedDate,
        time: formattedTime,
        comment: item.remark || item.comment || "-",
      };
    });
  };

  // Fetch sales order details if salesOrderNo present
  useEffect(() => {

    if (id) {
      dispatch(fetchProductSalesOrderById(id));
    }

  }, [dispatch, id, activeType]);

  const handleStatusChange = async (status: string) => {
    if (!id) return;
    try {
      // TODO: Implement status update API call
      toast.success(`Sales Order marked as ${status}`);
    } catch {
      toast.error("Failed to update status");
    }
  };

  const content = (
    <>
      {/* Header */}
      {!propId && (
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="d-flex align-items-center gap-2">
            <Button
              variant="link"
              className="p-0 text-muted"
              onClick={() => navigate(-1)}
              style={{ textDecoration: "none" }}
            >
              <ArrowBack style={{ fontSize: "1.25rem", cursor: "pointer" }} />
            </Button>
            <h5 className="mb-0" style={{ fontWeight: 600, fontSize: "20px" }}>
              View Sales Order
            </h5>
          </div>
        </div>
      )}
      {!propId && <hr />}
      <style>
        {`
      .followup-box {
  border: 1px solid #dee2e6;
  border-radius: 10px;
  background: #fff;
  padding: 12px;
}

/* Scrollable area */
.followup-scroll {
  max-height: 360px; /* ~4 comments */
  overflow-y: auto;
}

/* Card */
.followup-card {
  padding: 12px;
  border-radius: 8px;
  background-color: #f8f9fa;
  margin-bottom: 10px;
}

/* Avatar */
.avatar-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: #fff;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

/* Status badge */
.status-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 20px;
  color: #fff;
}

/* Comment text */
.comment-text {
  font-size: 14px;
  color: #212529;
  line-height: 1.4;
}

/* Scrollbar (optional) */
.followup-scroll::-webkit-scrollbar {
  width: 6px;
}

.followup-scroll::-webkit-scrollbar-thumb {
  background-color: #ced4da;
  border-radius: 10px;
}

/* Keep description/additional-details modal content (including images) inside modal */
.description-modal-content {
  overflow: auto;
  max-width: 100%;
  max-height: 70vh;
  word-wrap: break-word;
}
.description-modal-content img {
  max-width: 100%;
  height: auto;
  object-fit: contain;
}

      `}
      </style>


      <Card.Body>
        {/* Loading State */}
        {loading && <LoadingSpinner themeColor={MecordColors?.ThemeBGColor} />}

        {/* Error State */}
        {error && !loading && (
          <div className="text-center text-danger py-5">
            <h5>
              {typeof error === 'string'
                ? error
                : error?.message || error?.error || 'Failed to fetch sales order details'}
            </h5>
          </div>
        )}

        {/* Not Found State */}
        {!salesOrder && !loading && !error && (
          <div className="text-center py-5">
            <h5>Sales Order not found</h5>
          </div>
        )}

        {/* Content - Only show when not loading, no error, and salesOrder exists */}
        {!loading && !error && salesOrder && (
          <>
            {/* Sales Order Details OR Service */}
            <h5 className="mb-3">
              Sales Order Details
            </h5>
            <Row className="mb-4 ms-3">
              <Col md={6}>
                <p>
                  <strong>Sales Order No. :</strong>{" "}
                  {salesOrder?.sales_order_number || salesOrder?.sr_no || "-"}

                </p>
                {salesOrder?.pi_number && (
                  <p>
                    <strong>PI Number :</strong>{" "}
                    {salesOrder.pi_number}
                  </p>
                )}
                <p>
                  <strong>Initiated By :</strong>{" "}
                  {salesOrder?.initiated_by || "-"}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>Sales Order Date :</strong>{" "}
                  {formatDate(salesOrder?.sales_order_date)}
                </p>
                <p>
                  <strong>Valid Until Date :</strong>{" "}
                  {formatDate(salesOrder?.valid_until_date) || formatDate(salesOrder?.valid_untill_date)}
                </p>
                {/* <p>
                  <strong>Status :</strong>{" "}
                  <Badge
                    bg={
                      salesOrder?.sales_order_status === "draft"
                        ? "secondary"
                        : "primary"
                    }
                  >
                    {salesOrder?.sales_order_status || "-"}
                  </Badge>
                </p> */}
              </Col>
            </Row>

            <hr />
            {/* Company Details */}
            <h5 className="mb-3">Customer Details</h5>
            <Row
              className="mb-4 ms-1 me-1 p-3"
              rounded
              style={{
                backgroundColor: MecordColors.ActiveBackground,
                borderRadius: "10px",
              }}
            >
              <Row>
                <Col md={6}>
                  <p>
                    <strong>Company Name :</strong>{" "}
                    {customerDetails?.company_name ||
                      customerDetails?.customer_name ||
                      "-"}
                  </p>
                  <p>
                    <strong>Company Email :</strong>{" "}
                    {customerDetails?.company_email ||
                      contactDetails?.email ||
                      "-"}
                  </p>
                  <p>
                    <strong>Customer PO Number :</strong>{" "}
                    {customerDetails?.customer_po_number ||
                      customerDetails?.phone_number ||
                      "-"}
                  </p>
                  <p>
                    <strong>PO Document :</strong>{" "}
                    {customerDetails?.customer_po_documents &&
                      Array.isArray(customerDetails.customer_po_documents) &&
                      customerDetails.customer_po_documents.length > 0 ? (
                      <div>
                        {customerDetails.customer_po_documents.map(
                          (doc: string, index: number) => (
                            <div key={index} className="mb-1">
                              <a
                                href={doc}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-decoration-underline"
                              >
                                View Document {index + 1}
                              </a>
                            </div>
                          )
                        )}
                      </div>
                    ) : customerDetails?.customer_po_document_url ? (
                      <a
                        href={customerDetails.customer_po_document_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-decoration-underline"
                      >
                        View Document
                      </a>
                    ) : (
                      "-"
                    )}
                  </p>
                </Col>

                <Col md={6}>
                  <p>
                    <strong>Industry :</strong>{" "}
                    {customerDetails?.industry ||
                      billFrom?.industry_type ||
                      "-"}
                  </p>
                  <p>
                    <strong>Company Phone No. :</strong>{" "}
                    {customerDetails?.company_phone_number ||
                      customerDetails?.phone_number ||
                      "-"}
                  </p>
                  <p>
                    <strong>PO Date :</strong>{" "}
                    {formatDate(customerDetails?.customer_po_date)}
                  </p>
                </Col>
              </Row>

              <hr />
              <h5 className="mb-3 mt-3">Contact Details</h5>
              <Row>
                {Array.isArray(contactPersons) && contactPersons.length > 0 ? (
                  chunkArray(contactPersons, 2).map((row, rowIndex) => (
                    <React.Fragment key={rowIndex}>
                      {row.map((contact: any, colIndex: number) => (
                        <Col md={6} key={colIndex} className="mb-3">
                          <div className="p-2">
                            <p className="mb-1">
                              <strong>Contact Name :</strong>{" "}
                              {contact?.contact_person_name ||
                                contact?.name ||
                                "-"}
                            </p>
                            <p className="mb-1">
                              <strong>Email :</strong>{" "}
                              {contact?.contact_person_email ||
                                contact?.email ||
                                "-"}
                            </p>
                            <p className="mb-1">
                              <strong>Phone Number :</strong>{" "}
                              {contact?.contact_person_phone_no ||
                                contact?.phone_number ||
                                "-"}
                            </p>
                            {contact?.designation && (
                              <p className="mb-1">
                                <strong>Designation :</strong>{" "}
                                {contact.designation}
                              </p>
                            )}
                          </div>
                        </Col>
                      ))}
                    </React.Fragment>
                  ))
                ) : (
                  <Col md={6}>
                    <p>
                      <strong>Contact Name :</strong>{" "}
                      {contactDetails?.contact_person_name ||
                        contactDetails?.name ||
                        "-"}
                    </p>
                    <p>
                      <strong>Email :</strong>{" "}
                      {contactDetails?.contact_person_email ||
                        contactDetails?.email ||
                        "-"}
                    </p>
                    <p>
                      <strong>Phone Number :</strong>{" "}
                      {contactDetails?.contact_person_phone_no ||
                        contactDetails?.phone_number ||
                        "-"}
                    </p>
                  </Col>
                )}
              </Row>
            </Row>

            <hr />
            {/* Agent Details */}
            <Row className="mb-4">
              <Col md={6}>
                <h5 className="mb-3">Agent Details</h5>
                <p className="ms-4">
                  <strong>Agent Name :</strong> {agent.agent_name || "-"}
                </p>
              </Col>

              <Col md={6}>
                <h5 className="mb-3">Assign Member</h5>
                <div className="d-flex flex-wrap gap-2 ms-4">
                  {salesOrder.assigned_members &&
                    salesOrder.assigned_members.length > 0 ? (
                    salesOrder.assigned_members.map(
                      (member: any, idx: number) => {
                        const initials = `${member.first_name?.[0] || ""}${member.last_name?.[0] || ""
                          }`.toUpperCase();
                        const colors = [
                          { bg: "#fee2e2", circle: "#ef4444", text: "#991b1b" },
                          { bg: "#ccfbf1", circle: "#0d9488", text: "#115e59" },
                          { bg: "#e0e7ff", circle: "#4f46e5", text: "#3730a3" },
                          { bg: "#fef3c7", circle: "#d97706", text: "#92400e" },
                        ];
                        const color = colors[idx % colors.length];

                        return (
                          <div
                            key={member.user_id || idx}
                            className="d-flex align-items-center p-1 pe-3 rounded"
                            style={{
                              backgroundColor: color.bg,
                              border: "none",
                            }}
                          >
                            <div
                              className="d-flex align-items-center justify-content-center rounded me-2"
                              style={{
                                width: "24px",
                                height: "24px",
                                backgroundColor: color.circle,
                                color: "#fff",
                                fontSize: "0.7rem",
                                fontWeight: "bold",
                              }}
                            >
                              {initials || "U"}
                            </div>
                            <span
                              style={{
                                fontSize: "0.85rem",
                                fontWeight: "600",
                                color: "#1e293b",
                              }}
                            >
                              {member.first_name} {member.last_name}
                            </span>
                          </div>
                        );
                      }
                    )
                  ) : (
                    <span className="text-muted">No members assigned</span>
                  )}
                </div>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={6}>
              
              <h5 className="mb-3">Tags</h5>
              <div className="d-flex flex-wrap gap-2 ms-4">
                    {Array.isArray(salesOrder?.tags) &&
                    salesOrder.tags.length > 0 ? (
                      <span className="d-inline-flex flex-wrap gap-2 mt-1">
                        {salesOrder.tags.map((tag: string) => (
                          <span
                            key={tag}
                            className="badge bg-light text-dark d-flex align-items-center rounded-2"
                            style={{
                              border: "1px solid #dee2e6",
                              padding: "4px 8px",
                              fontSize: "11px",
                            }}
                          >
                            {tag}
                          </span>
                        ))}
                      </span>
                    ) : (
                      <span>-</span>
                    )}
                </div>
              </Col>
            </Row>

            {/* Technician Details for Service */}
            {activeType == "service" && (
              <>
                <hr />
                <h5 className="mb-3">Technician Details</h5>
                <Row className="mb-4 ms-3">
                  <Col md={6}>
                    <p>
                      <strong>Assigned Technician :</strong>{" "}
                      {/* {agent.agent_name || "-"} */}
                    </p>
                  </Col>
                </Row>
              </>
            )}

            <hr />
            {/* PBG (Performance Bank Guarantee) Details */}
            <h5 className="mb-3">PBG (Performance Bank Guarantee) Details</h5>
            <Row className="mb-4 ms-3">
              <Col md={6}>
                <p>
                  <strong>PBG Applicable :</strong>{" "}
                  {salesOrder?.pbg_applicable ? "Yes" : "No"}
                </p>
                <p>
                  <strong>PBG Date :</strong>{" "}
                  {formatDate(salesOrder?.pbg_date)}
                </p>
                <p>
                  <strong>Amount:</strong>{" "}
                  {salesOrder?.pbg_amount
                    ? `${"₹"}${formatIndianAmount(salesOrder.pbg_amount)}`
                    : "-"}
                </p>
                <p>
                  <strong>PBG Status :</strong> {salesOrder?.pbg_status || "-"}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>PBG Number :</strong>{" "}
                  {salesOrder?.pbg_number || "-"}
                </p>
                <p>
                  <strong>Bank Name :</strong> {salesOrder?.bank_name || "-"}
                </p>
                <p>
                  <strong>Validity :</strong>{" "}
                  {formatDate(salesOrder?.pbg_validity) || "-"}
                </p>
                <p>
                  <strong>Upload Document :</strong>{" "}
                  {salesOrder?.pbg_documents &&
                    Array.isArray(salesOrder.pbg_documents) &&
                    salesOrder.pbg_documents.length > 0 ? (
                    <div>
                      {salesOrder.pbg_documents.map(
                        (doc: string, index: number) => (
                          <div key={index} className="mb-1">
                            <a
                              href={doc}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-decoration-underline"
                            >
                              View Document {index + 1}
                            </a>
                          </div>
                        )
                      )}
                    </div>
                  ) : typeof salesOrder?.pbg_documents === "string" ? (
                    <a
                      href={salesOrder.pbg_documents}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-underline"
                    >
                      View Document
                    </a>
                  ) : (
                    "-"
                  )}
                </p>
              </Col>
            </Row>

            <hr />
            {/* Currency & Exchange Details */}
            <Row className="mb-4">
              <Col md={6}>
                <h5 className="mb-3">Currency & Exchange Details</h5>
                <Row>


                  <p className="ms-4">
                    <strong>Currency :</strong>{" "}
                    {salesOrder?.currency_symbol || salesOrder?.currency || "-"}
                  </p>
                </Row>
                <Row>
                  <p className="ms-4">

                    <strong>Exchange Rate (in INR) :</strong>{" "}
                    {salesOrder?.currency_rate_in_inr || "-"}
                  </p>
                </Row>
              </Col>
              <Col md={6}>
                <Row>

                  <h5 className="mb-3">EMD (Earnest Money Deposit) Details</h5>
                  <p className="ms-4">
                    <strong>EMD Mode :</strong>{" "}
                    {salesOrder?.mode_of_emd || "-"}
                  </p>
                </Row>
                <Row>
                  <p className="ms-4">

                    <strong>EMD Amount :</strong>{" "}
                    {salesOrder?.emd_amount
                      ? `${"₹"}${formatIndianAmount(salesOrder.emd_amount)}`
                      : "-"}
                  </p>
                </Row>
              </Col>
            </Row>
            <hr />
            {/* GST & Taxation Details */}
            {/* <h5 className="mb-3">GST & Taxation Details</h5>
            <Row className="mb-4 ms-3">
              <Col md={6}>
                <p>
                  <strong>Compositional GST :</strong>{" "}
                  {salesOrder?.composition_gst ? "Yes" : "No"}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>GST % :</strong>{" "}
                  {salesOrder?.select_composition_gst || "-"}
                </p>
              </Col>
            </Row>

            <hr /> */}


            {/* Inspection & Installation Details */}
            <h5 className="mb-3">Inspection & Installation Details</h5>
            <Row className="mb-4 ms-3">
              <Col md={6}>
                <p>
                  <strong>Inspection :</strong>{" "}
                  {salesOrder?.inspection || "-"}
                </p>
                <p>
                  <strong>Installation :</strong>{" "}
                  {salesOrder?.installation || "-"}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>Inspection Date :</strong>{" "}
                  {formatDate(salesOrder?.inspection_date)}
                </p>
                <p>
                  <strong>Installation Date :</strong>{" "}
                  {formatDate(salesOrder?.installation_date)}
                </p>
              </Col>
            </Row>

            <hr />
            {/* Billing Details */}
            <h5 className="mb-3">Billing Details</h5>
            <Row
              className="ms-1 me-1 p-3"
              rounded
              style={{
                backgroundColor: MecordColors.ActiveBackground,
                borderRadius: "10px",
              }}
            >
              <Col md={6}>
                <p>
                  <strong>Bill From :</strong>{" "}
                </p>
                {billFrom?.org_address && (
                  <p className="mt-1 text-muted small">
                    {billFrom.org_address}, {billFrom.org_city},{" "}
                    {billFrom.org_state} - {billFrom.org_pincode}
                  </p>
                )}
              </Col>
              <Col md={6}>
                <p>
                  <strong>Bill To :</strong>{" "}
                </p>
                {billTo?.address && (
                  <p className="mt-1 text-muted small">
                    {billTo.address}, {billTo.city}, {billTo.state} -{" "}
                    {billTo.pincode || billTo.pin_code}
                  </p>
                )}
              </Col>
            </Row>

            <hr />
            {/* Products/Items */}
            <h5 className="mb-3">Products</h5>
            <div
              className="table-responsive p-3 mb-4"
              style={{
                backgroundColor: MecordColors.ActiveBackground,
                borderRadius: "10px",
              }}
            >
              <div
                className="overflow-auto"
                style={{}}
              >
                <table
                  style={{
                    width: "100%",
                    minWidth: "2000px",
                    borderCollapse: "collapse",
                    fontSize: "0.75rem",
                    whiteSpace: "nowrap",
                  }}
                >
                  <thead style={{ backgroundColor: "#f8f9fa" }}>
                    <tr>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Sr No.
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Products
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Additional Details
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Make
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Model
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Product Code
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Warranty in Month
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Warranty Date
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Serviceable
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Quantity
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Unit
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Unit Price
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Rate in Currency
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Gross Value
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Discount/Flat
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Discount Value
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Net Value
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        GST(%)
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        SGST(%)
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        CGST(%)
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        IGST(%)
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        GST Value
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Total
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Shipping Address
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          borderBottom: "1px solid #eee",
                          textAlign: "left",
                        }}
                      >
                        Availability
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ backgroundColor: "#fff" }}>
                    {salesOrder?.sales_order_product_items?.length > 0 ? (
                      salesOrder.sales_order_product_items.map(
                        (item: any, idx: number) => (
                          <tr key={item.id || item.item_id || idx}>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {idx + 1}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                                verticalAlign: "middle",
                              }}
                            >
                              <div style={{ display: "inline-flex", flexDirection: "column", alignItems: "flex-start" }}>
                                <div className="d-flex align-items-center gap-1">
                                  <div
                                    style={{
                                      fontWeight: 600,
                                      fontSize: "0.75rem",
                                    }}
                                  >
                                    {item.item_name || item.product_name || "-"}
                                    <div
                                  style={{
                                    color: "#666",
                                    fontSize: "0.65rem",
                                  }}
                                >
                                  SKU: {item.product_sku || item.sku || "-"} | HSN Code:{" "}
                                  {item.hsn_code || "-"}
                                </div>
                                  </div>
                                  <InfoIcon
                                    style={{
                                      cursor: "pointer",
                                      color: tableStyles.primaryColor || MecordColors?.ThemeBGColor,
                                      fontSize: "18px",
                                      flexShrink: 0,
                                    }}
                                    onClick={() => {
                                      const content = item.prod_description ?? item.description ?? "";
                                      setDescriptionModalContent(content);
                                      setDescriptionModalProductName(item.item_name || item.product_name || "");
                                      setShowDescriptionModal(true);
                                    }}
                                  />
                                </div>
 
                              </div>
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                                verticalAlign: "middle",
                              }}
                            >
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <InfoIcon
                                  style={{
                                    cursor: "pointer",
                                    color: tableStyles.primaryColor || MecordColors?.ThemeBGColor,
                                    fontSize: "18px",
                                  }}
                                  onClick={() => {
                                    const content = item.additional_details ?? "";
                                    setAdditionalDetailsContent(content);
                                    setAdditionalDetailsProductName(item.item_name || item.product_name || "");
                                    setShowAdditionalDetailsModal(true);
                                  }}
                                />
                              </div>
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {item.make_name || "-"}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {item.model_name || "-"}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {item.product_code || item.sku || "-"}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {item.warrenty_in_months || "-"}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {formatDate(item.warrenty_date) || "-"}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {item.is_serviceable || item.serviceable ? "Yes" : "No"}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {item.product_quantity || item.quantity || 0}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {item.unit_name || "-"}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              ₹{" "}
                              {formatIndianAmount(item.unit_price || 0)}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {salesOrder?.currency_symbol || "₹"}{" "}
                              {formatIndianAmount(item.rate_in_currency)}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {salesOrder?.currency_symbol || "₹"}{" "}
                              {formatIndianAmount(item.gross_value || item.product_total)}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {(() => {
                                // discount_value is now the RAW input value (10 for 10% or 500 for ₹500)
                                const discountValueInput = parseFloat(item.discount_value) || 0;
                                const discountType = item.discount_type || "currency";

                                if (discountType === "%" || discountType === "percentage") {
                                  // Display raw percentage value
                                  return `${formatIndianAmount(discountValueInput)}%`;
                                } else {
                                  // Display "Flat" for currency/flat discounts
                                  return "Flat";
                                }
                              })()}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {(() => {
                                // Calculate the actual discount amount from raw discount_value
                                const discountValueInput = parseFloat(item.discount_value) || 0;
                                const discountType = item.discount_type || "currency";
                                const grossValue = parseFloat(item.gross_value || item.product_total || 0) || 0;

                                let calculatedDiscountAmount = 0;
                                if (discountType === "%" || discountType === "percentage") {
                                  // Calculate: (gross * percentage) / 100
                                  calculatedDiscountAmount = (grossValue * discountValueInput) / 100;
                                } else {
                                  // Currency discount - use raw value directly (capped at gross)
                                  calculatedDiscountAmount = Math.min(discountValueInput, grossValue);
                                }

                                return `${salesOrder?.currency_symbol || "₹"}${formatIndianAmount(calculatedDiscountAmount)}`;
                              })()}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {salesOrder?.currency_symbol || "₹"}{" "}
                              {formatIndianAmount(item.product_net_total || item.net_value)}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {item.gst_percentage || "-"}
                              {item.gst_percentage ? "%" : ""}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {item.sgst_percentage || "-"}
                              {item.sgst_percentage ? "%" : ""}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {item.cgst_percentage || "-"}
                              {item.cgst_percentage ? "%" : ""}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {item.igst_percentage || "-"}
                              {item.igst_percentage ? "%" : ""}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              { "₹"}{" "}
                              {formatIndianAmount(item.gst_amount || item.gst_value)}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {salesOrder?.currency_symbol || "₹"}{" "}
                              {formatIndianAmount(item.product_total || item.total)}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {item.shipping_address ? (
                                <span style={{ fontSize: "0.7rem" }}>
                                  {item.shipping_address.address}
                                  {item.shipping_address.city &&
                                    `, ${item.shipping_address.city}`}
                                  {item.shipping_address.state &&
                                    `, ${item.shipping_address.state}`}
                                  {item.shipping_address.pincode &&
                                    ` - ${item.shipping_address.pincode}`}
                                </span>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {item.item_availability || item.availability || "-"}
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan={25}
                          style={{
                            padding: "8px",
                            borderBottom: "1px solid #eee",
                            textAlign: "center",
                            color: "#666",
                            paddingTop: "20px",
                            paddingBottom: "20px",
                          }}
                        >
                          No items added yet.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>






            {/* Terms & Conditions and Notes & Attachments */}
            <hr />
            <Row className="g-4">
              <Col md={6}>
                <h5 className="mb-3">Terms & Conditions</h5>
                <div
                  className="p-3"
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    border: "1px solid #eee",
                  }}
                >
                  {(() => {
                    // Group terms by type to handle multiple options per type
                    const groupedTerms: Record<string, string[]> = {};
                    salesOrder?.terms_and_conditions?.forEach(
                      (item: any) => {
                        if (item.type) {
                          if (!groupedTerms[item.type]) {
                            groupedTerms[item.type] = [];
                          }
                          // Handle both string and array options
                          if (Array.isArray(item.options)) {
                            item.options.forEach((opt: string) => {
                              if (
                                opt &&
                                !groupedTerms[item.type].includes(opt)
                              ) {
                                groupedTerms[item.type].push(opt);
                              }
                            });
                          } else if (item.options) {
                            // If options is a string, check if it's newline-separated
                            const options = item.options
                              .split("\n")
                              .filter((opt: string) => opt.trim());
                            options.forEach((opt: string) => {
                              if (
                                opt &&
                                !groupedTerms[item.type].includes(opt)
                              ) {
                                groupedTerms[item.type].push(opt);
                              }
                            });
                          }
                        }
                      }
                    );

                    if (Object.keys(groupedTerms).length === 0) {
                      return (
                        <p className="text-muted" style={{ fontSize: "0.75rem" }}>
                          No terms and conditions available
                        </p>
                      );
                    }

                    return Object.entries(groupedTerms).map(
                      ([type, options], idx) => (
                        <div key={idx} className="mb-3">
                          <strong
                            style={{
                              fontSize: "0.75rem",
                              display: "block",
                              marginBottom: "0.5rem",
                            }}
                          >
                            {type}
                          </strong>
                          <ul
                            style={{
                              fontSize: "0.7rem",
                              color: "#666",
                              marginLeft: "20px",
                              paddingLeft: "0",
                              listStyle: "disc",
                            }}
                          >
                            {options.map(
                              (option: string, optIdx: number) => (
                                <li
                                  key={optIdx}
                                  style={{ marginBottom: "4px" }}
                                >
                                  {option}
                                </li>
                              )
                            )}
                          </ul>
                          {idx <
                            Object.keys(groupedTerms).length - 1 && (
                              <hr
                                style={{
                                  width: "100%",
                                  marginTop: "12px",
                                }}
                              />
                            )}
                        </div>
                      )
                    );
                  })()}
                </div>

              </Col>

              <Col md={6}>
                <h5 className="mb-3">Total Summary</h5>
                <div
                  className="p-3"
                  style={{
                    backgroundColor: MecordColors.ActiveBackground,
                    borderRadius: "10px",
                  }}
                >
                  <Row>
                    <Col md={6}>
                      <p>
                        <strong>Sub Total (Before Discount) :</strong>
                      </p>
                    </Col>
                    <Col md={6} className="text-end">
                      <p>
                        {salesOrder?.currency_symbol || "₹"}{" "}
                        {formatIndianAmount(salesOrder?.sub_total_before_discount || 0)}
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <p>
                        <strong>Total Discount Value :</strong>
                      </p>
                    </Col>
                    <Col md={6} className="text-end">
                      <p>
                        {salesOrder?.currency_symbol || "₹"}{" "}
                        {formatIndianAmount(salesOrder?.total_discount_value || salesOrder?.total_item_discounts || 0)}
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <p>
                        <strong>Net Taxable Value :</strong>
                      </p>
                    </Col>
                    <Col md={6} className="text-end">
                      <p>
                        {salesOrder?.currency_symbol || "₹"}{" "}
                        {formatIndianAmount(salesOrder?.total_net_value || salesOrder?.total_net_amount || 0)}
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <p>
                        <strong>Total GST Value :</strong>
                      </p>
                    </Col>
                    <Col md={6} className="text-end">
                      <p>
                        {salesOrder?.currency_symbol || "₹"}{" "}
                        {formatIndianAmount(salesOrder?.total_gst_value || 0)}
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <p>
                        <strong>Total Amount :</strong>
                      </p>
                    </Col>
                    <Col md={6} className="text-end">
                      <p className="fw-bold">
                        {salesOrder?.currency_symbol || "₹"}{" "}
                        {formatIndianAmount(salesOrder?.grand_total_amount || 0)}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <hr />


            {/* Status Remarks & History */}
            {/* Retention Details */}
            {/* {salesOrder?.retention_applicable && ( */}
            <>
              <h5 className="mb-3">Retention Details</h5>
              <Row className="ms-3">
                <Col md={6}>

                  <p>
                    <strong>Retention Type:</strong>{" "}
                    {salesOrder?.retention_type
                      ? salesOrder.retention_type.charAt(0).toUpperCase() +
                      salesOrder.retention_type.slice(1)
                      : "-"}
                  </p>


                </Col>
                <Col md={6}>
                  {
                    salesOrder?.retention_type == "percentage" && (

                      <p>
                        <strong>Percentage:</strong>{" "}
                        {salesOrder?.retention_percentage
                          ? `${salesOrder.retention_percentage}%`
                          : "-"}
                      </p>

                    )}
                </Col>
              </Row>
              <Row className="ms-3">
                <Col>
                  <p>
                    <strong> Retention Amount:</strong>{" "}
                    {salesOrder?.retention_amount
                      ? `${salesOrder?.currency_symbol || "₹"}${formatIndianAmount(salesOrder.retention_amount)}`
                      : "-"}
                  </p>

                </Col>


                <Col>
                  <p>
                    <strong> Follow Up Date:</strong>{" "}
                    {(() => {
                      const retentionFollowUpDate = getFollowUpDateByCategory(
                        "Retention",
                        true
                      );
                      if (retentionFollowUpDate) {
                        return formatDateDDMMYYYY(retentionFollowUpDate);
                      }
                      return "-";
                    })()}
                  </p>

                </Col>
              </Row>
              <hr />
            </>
            {/* )} */}

            <Row>
              <Col md={6}>
                <h5 className="mb-3">Notes & Attachments</h5>
                <Table bordered className="bg-white">
                  <tbody>
                    <tr>
                      <td
                        style={{
                          minWidth: "70px",
                          fontWeight: 500,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Notes
                      </td>
                      <td style={{ whiteSpace: "pre-wrap" }}> 
                        {salesOrder?.notes ||
                          "-"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
                {salesOrder?.attachments &&
                  salesOrder.attachments.length > 0 ? (
                  <div className="mt-3">
                    <strong className="d-block mb-2">
                      Attachments:
                    </strong>
                    <AttachmentList attachments={salesOrder.attachments} />
                    {/* <div className="d-flex flex-wrap gap-2">
                      {salesOrder.attachments.map(
                        (url: string | any, idx: number) => {
                          const fileUrl =
                            typeof url === "string"
                              ? url
                              : url?.file_url || url?.file_path;
                          const fileName = fileUrl?.split("/").pop();
                          return (
                            <a
                              key={idx}
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-decoration-none"
                            >
                              <span
                                className="badge bg-secondary"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {fileName || `Attachment ${idx + 1}`}
                              </span>
                            </a>
                          );
                        }
                      )}
                    </div> */}
                  </div>
                ) : (
                  <p className="text-muted mt-2">No attachments</p>
                )}
              </Col>
            </Row>
            <hr />
            <Row className="mt-3">
              <h5 className="mt-3 mb-3">Status Remarks & History</h5>
              <Col lg={6} sm={12} md={12} className="mb-3">
                <div className="followup-box">
                  <div className="followup-scroll">
                    {transformStatusRemarks(
                      salesOrder?.status_remarks_and_history
                    ).length > 0 ? (
                      transformStatusRemarks(
                        salesOrder?.status_remarks_and_history
                      ).map((item, index) => (
                        <div className="followup-card" key={index}>
                          <div className="d-flex align-items-start gap-3">
                            <div
                              className="avatar-circle"
                              style={{
                                backgroundColor: item.color || "#4F46E5",
                              }}
                            >
                              {item.initials}
                            </div>

                            <div className="flex-grow-1">
                              <div className="d-flex align-items-center gap-2">
                                <strong>{item.employee_name}</strong>
                                <span
                                  className="status-badge"
                                  style={{
                                    backgroundColor: item.statusColor,
                                  }}
                                >
                                  {item.status}
                                </span>
                              </div>

                              <small className="text-muted">
                                {item.date} • {item.time}
                              </small>
                            </div>
                          </div>

                          <div className="mt-2 comment-text">
                            {item.comment}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-center text-muted py-3">
                        No status remarks available
                      </div>
                    )}
                  </div>
                </div>
              </Col>

            </Row>
            {/* Back Button */}
            <Row className="mt-3">
              <Col className="d-flex justify-content-center gap-3">
                <CancelButton showConfirmation={false} onClick={() => navigate(-1)} />
              </Col>
            </Row>
          </>
        )}
      </Card.Body>

      {/* Product Description Modal (Info icon) */}
      <Modal
        show={showDescriptionModal}
        onHide={() => {
          setShowDescriptionModal(false);
          setDescriptionModalContent("");
          setDescriptionModalProductName("");
        }}
        centered
      >
        <Modal.Header
          closeButton
          style={{
            fontFamily: tableStyles.header.fontFamily,
            fontSize: tableStyles.header.fontSize,
            borderBottom: "1px solid #dee2e6",
          }}
        >
          <Modal.Title
            style={{
              fontFamily: tableStyles.header.fontFamily,
              fontSize: tableStyles.header.fontSize,
              fontWeight: tableStyles.header.fontWeight,
            }}
          >
            Product Description
            {descriptionModalProductName ? ` - ${descriptionModalProductName}` : ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            fontFamily: filterPopoverStyles.fontFamily,
            fontSize: filterPopoverStyles.fontSize,
            overflow: "hidden",
            maxWidth: "100%",
          }}
        >
          {descriptionModalContent ? (
            <div
              className={`${DETAILS_BG} description-modal-content`}
              style={{
                minHeight: "80px",
                fontFamily: filterPopoverStyles.fontFamily,
                fontSize: filterPopoverStyles.fontSize,
                overflow: "auto",
                maxWidth: "100%",
              }}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(descriptionModalContent),
              }}
            />
          ) : (
            <div
              className="text-muted"
              style={{
                fontFamily: filterPopoverStyles.fontFamily,
                fontSize: filterPopoverStyles.fontSize,
              }}
            >
              No description available.
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="secondary"
            className="rounded"
            style={{
              fontFamily: filterPopoverStyles.button.fontFamily,
              fontSize: filterPopoverStyles.button.fontSize,
              borderColor: filterPopoverStyles.cancelButton.borderColor,
              color: filterPopoverStyles.cancelButton.color,
              backgroundColor: "#fff",
            }}
            onClick={() => {
              setShowDescriptionModal(false);
              setDescriptionModalContent("");
              setDescriptionModalProductName("");
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Additional Details Modal (Info icon) */}
      <Modal
        show={showAdditionalDetailsModal}
        onHide={() => {
          setShowAdditionalDetailsModal(false);
          setAdditionalDetailsContent("");
          setAdditionalDetailsProductName("");
        }}
        centered
      >
        <Modal.Header
          closeButton
          style={{
            fontFamily: tableStyles.header.fontFamily,
            fontSize: tableStyles.header.fontSize,
            borderBottom: "1px solid #dee2e6",
          }}
        >
          <Modal.Title
            style={{
              fontFamily: tableStyles.header.fontFamily,
              fontSize: tableStyles.header.fontSize,
              fontWeight: tableStyles.header.fontWeight,
            }}
          >
            Additional Details
            {additionalDetailsProductName ? ` - ${additionalDetailsProductName}` : ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            fontFamily: filterPopoverStyles.fontFamily,
            fontSize: filterPopoverStyles.fontSize,
            overflow: "hidden",
            maxWidth: "100%",
          }}
        >
          {additionalDetailsContent ? (
            <div
              className={`${DETAILS_BG} description-modal-content`}
              style={{
                minHeight: "80px",
                fontFamily: filterPopoverStyles.fontFamily,
                fontSize: filterPopoverStyles.fontSize,
                overflow: "auto",
                maxWidth: "100%",
              }}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(additionalDetailsContent),
              }}
            />
          ) : (
            <div
              className="text-muted"
              style={{
                fontFamily: filterPopoverStyles.fontFamily,
                fontSize: filterPopoverStyles.fontSize,
              }}
            >
              No additional details available.
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="secondary"
            className="rounded"
            style={{
              fontFamily: filterPopoverStyles.button.fontFamily,
              fontSize: filterPopoverStyles.button.fontSize,
              borderColor: filterPopoverStyles.cancelButton.borderColor,
              color: filterPopoverStyles.cancelButton.color,
              backgroundColor: "#fff",
            }}
            onClick={() => {
              setShowAdditionalDetailsModal(false);
              setAdditionalDetailsContent("");
              setAdditionalDetailsProductName("");
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

    </>
  );

  return propId ? <div className="p-0">{content}</div> : <PageContainer>{content}</PageContainer>;
};

export default ViewProductSalesOrderPage;
